import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { IInvoiceAdjustmentRequest } from "@/api_framework/api_modals/payment";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

interface IAPIResponse {
  status: boolean;
  message: string;
  data: IInvoiceAdjustmentRequest;
}


export const useInvoiceAdjustmentRequestDetailsAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (requestId: string): Promise<{ status: boolean; message: IInvoiceAdjustmentRequest | null }> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        return await axios
          .get(`${PAYMENT_MODULE?.INVOICE_ADJUSTMENT_REQUESTS?.baseURL}/${encodeURIComponent(requestId)}`, {
            headers: { Authorization: `${accessToken}` },
          })
          .then((res: AxiosResponse<IAPIResponse>) => {
            if (res.data.status) {
              return { status: true, message: res.data.data };
            }
            return { status: false, message: null };
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config?.["curlCommand"]);
            captureError(e);
            return { status: false, message: null };
          });
      } catch (e) {
        captureError(e as AxiosError);
        return { status: false, message: null };
      }
    },
    [captureError, configuration.localStorage.ACCESS_TOKEN.key, sendCurl],
  );

  return { execute };
};
